import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';
import { useAdminRole } from '../../hooks/useAdminRole';
import { getMinRoleForPath } from '../../config/adminNav';

function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-center px-6">
      <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center">
        <FiLock className="w-6 h-6 text-offwhite/40" />
      </div>
      <p className="font-display font-bold text-lg text-offwhite">Access denied</p>
      <p className="text-offwhite/40 text-sm max-w-sm">
        Your admin role doesn't have permission to view this page.
      </p>
    </div>
  );
}

/**
 * Gates a route by the minimum admin role required for the current path
 * (ROUTE_MIN_ROLE, shared with the Sidebar's visibility rules). The backend
 * is the real authorization boundary — this exists so a lower-privileged
 * admin can't reach a page's UI at all, rather than relying solely on the
 * sidebar hiding the link.
 */
export function RoleProtectedRoute({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { hasRole } = useAdminRole();
  const minRole = getMinRoleForPath(pathname);

  if (!hasRole(minRole)) return <AccessDenied />;
  return <>{children}</>;
}
